import BigNumber from 'bignumber.js';

export const alpaUnit = (amount: BigNumber | number | string) => {
  return new BigNumber(amount).dividedBy(1000000000000000000);
};

export const addressFormat = (address: string): string => {
  if (address.length <= 10) {
    return address;
  }
  return `${address.substring(0, 6)}...${address.substring(address.length - 4, address.length)}`;
};

const ONE = new BigNumber(1);
const TWO = new BigNumber(2);
export const sqrt = (y: BigNumber): BigNumber => {
   let z = y;
   let x = y.div(TWO).plus(ONE);
   while (x.minus(z).isNegative()) {
      z = x;
      x = y.div(x).plus(x).div(TWO);
   }
   return z;
};
